import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import {environment} from "../environments/environment";
import {IProduct, Product} from "../models/product.model";

@Injectable({
  providedIn : 'root'
})

export class ProductService{

  constructor(private http : HttpClient){}

  getProduct() : Observable<Product>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<Product>(`${environment.url}/product`,{'headers': headers});
  }

  loadProduct_v1(page: number, size: number) : Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/v1/product/connected?fields=shop,category,postSubProdcuts,productType` + (size ? '?page=' + page + '&size=' + size : ''),{'headers': headers});
  }

  loadSubscribeProduct(page: number, size: number) : Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product/product-subscribe?fields=shop,category,postSubProdcuts,productType` + (size ? '&page=' + page + '&size=' + size : ''),{'headers': headers});
  }

  loadSubscribeProductByDate(startDate: any, endDate: any,page: number, size: number) : Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product/product-subscribe?fields=shop,category,postSubProdcuts,productType&startDate=${startDate}&endDate=${endDate}` + (size ? '&page=' + page + '&size=' + size : ''),{'headers': headers});
  }
  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/product` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getProductBycurrentSearch(search: string, page: number, size: number){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product` + ('/_search?search=name:' + search +'&page=' + page + "&size=" + size),{'headers': headers});
  }

  getProductSubtypeCharacteristic(idProd: any):Observable<any>{
    // api/characteristic/productType/{id}
    return this.http.get<any>(`${environment.url}/characteristic/productType/`+idProd);
  }

  getProductCategorySubType(idCat: any):Observable<any>{
    //api/product_type/category/{id}
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product_type/category/`+idCat);
  }

  // Retourne le produit passer passer en annonce à partir de son identidiant
  getProductbyProductId(productId: string):Observable<any>{
    //api/product/productID/{productID}
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product/product/`+productId,{'headers': headers});
  }

  saveProduct(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/product`,Product,{'headers': headers});
  }

  saveProductBack(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/product/back`,Product,{'headers': headers});
  }



  getIdProduct(idA:number)
  {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/product/`+idA,{'headers': headers});
  }

  getIdProductByShop(idA: any) {
    return this.http.get(`${environment.url}/product/shop/`+ idA);
  }

  updateProduct(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/product/update/`+Product.id,Product,{'headers': headers});
  }
  updateProductBackOffice(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/product/back/`+Product.id,Product,{'headers': headers});
  }
  // deleteProduct(idA:number)
  // {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
  //   return this.http.delete(`${environment.url}/product/`+idA,{'headers': headers});
  // }

  deleteProduct(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.delete(`${environment.url}/product/`+Product.id,{'headers': headers});
  }

  deleteProduct_new(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.delete(`${environment.url}/product/new/`+Product.id,{'headers': headers});
  }

  //api/product/gift-card/{id}
  deleteKahpooProduct(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.delete(`${environment.url}/product//gift-card/`+Product.id,{'headers': headers});
  }

  getSubProductbySubproductId(subProductId: string):Observable<any>{
    return this.http.get<any>(`${environment.url}/subProduct/subProductID/`+subProductId);
  }

  getSubProductbyProductId(productId: string):Observable<any>{
    return this.http.get<any>(`${environment.url}/v1/product/bySubProductID/`+productId);
  }

  getProductByProductID(productID: string){
    return this.http.get<any>(`${environment.url}/product/productID/${productID}`);
  }

  //api/product/byShop/{shop_id}
  getProductByShop(shopId: number):Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product/byShop/`+shopId,{'headers': headers});
  }

  getProductByShopPaged(idShop: number, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id') || '');
    return this.http.get<any>(`${environment.url}/product/byShopPaged/${idShop}${size ? '?page=' + page + '&size=' + size : ''}`, { headers });
  }

  getKahpooShopsProductByDate(shop_id: number, startDate: any, endDate: any ,page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/product/allshopproducts?shop_id=${shop_id}&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  getProductEmployeJob(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/product/product-employe-job` + (size ? '?page=' + page + '&size=' + size : ''),{'headers': headers});
  }

  getProductEmployeJobByDate_v1(startDate: any, endDate: any, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/product/product-employe-offer?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`, { headers: headers });
  }

  // Liste des offre d'emploi créer entre deux date
  getProductEmployeJobByDate(shop_id: number, startDate: any, endDate: any ,page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    // return this.http.get(`${environment.url}/v1/posts/job?fields=postProducts,postServiceModels,postSubProducts&page=${page}&size=${size}`);
    return this.http.get(`${environment.url}/v1/posts/job?fields=postProducts,postServiceModels,postSubProducts&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  saveOffer(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/product/job`,Product,{'headers': headers});
  }

  saveKahpooOffer(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/product/kahpoo/job`,Product,{'headers': headers});
  }

  loadOffer():Observable<IProduct>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product/job_user`)
  }

  loadKahpooOffer(page: number, size: number):Observable<IProduct>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/product/kahpoo/job_user`+(size ? '?page=' + page + '&size=' + size : ''),{'headers': headers})
  }

  updateJobProduct(Product:IProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/product/kahpoo/job/`+Product.id,Product,{'headers': headers});
  }

  updateJobProduct_new(product: IProduct, typeOffer: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    headers = headers.set('Content-Type', 'application/json');
    const url = `${environment.url}/product/kahpoo/job/${product.id}?typeOffer=${typeOffer}`;
    return this.http.put<any>(url, product, { headers: headers });
  }

  getAllEmployeOfferProductSearched(name?: string, createdAt?: string, value?: string, page: number = 0, size: number = 10): Observable<any> {
    const headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem("kapo_session_id") || '');

    let params = new HttpParams();
    if (name) {
      params = params.set('name', name);
    }
    if (createdAt) {
      params = params.set('createdAt', createdAt);
    }
    if (value) {
      params = params.set('value', value);
    }
    params = params.set('page', page.toString())
                   .set('size', size.toString());

    return this.http.get<any>(`${environment.url}/product/search-product`, { params: params, headers: headers });
  }


}
